import { useEffect } from "react";

import { driver } from "@/lib/driver-js";

type HighlightTarget = {
	element: string;
	title: string;
	description: string;
};

export const useHighlight = (target: HighlightTarget | null) => {
	useEffect(() => {
		if (!target) return;

		const driverObj = driver({
			showProgress: false,
			allowClose: true,
			popoverClass: "start-guide-popover",
			onCloseClick: () => {
				driverObj.destroy();
			},
		});

		// DOM が描画された後にハイライトを実行
		const timeoutId = setTimeout(() => {
			driverObj.highlight({
				element: target.element,
				popover: {
					title: target.title,
					description: target.description,
					showButtons: ["close"],
					side: "bottom",
					align: "start",
				},
			});
		}, 500);

		return () => {
			clearTimeout(timeoutId);
			driverObj.destroy();
		};
	}, [target]);
};
